import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import elementZhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementJALocale from 'element-ui/lib/locale/lang/ja'
import enUSLocale from './en_US.json'
import zhTWLocale from './zh_TW.json'
import zhCNLocale from './zh_CN.json'
import msMYLocale from './ms_MY.json'
import thTHLocale from './th_TH.json'
import jaLocale from './ja.json'
import store from '../store'
import { I18nLocaleCode } from '@/enums/translation'
Vue.use(VueI18n)

const defaultLanguage = I18nLocaleCode.TW
const languagesAvailable = [I18nLocaleCode.TW, I18nLocaleCode.CN, I18nLocaleCode.JP, I18nLocaleCode.TH, I18nLocaleCode.EN, I18nLocaleCode.MY]

const messages = {
  [I18nLocaleCode.EN]: {
    ...enUSLocale,
    ...elementEnLocale
  },
  [I18nLocaleCode.TW]: {
    ...zhTWLocale,
    ...elementZhTWLocale
  },
  [I18nLocaleCode.CN]: {
    ...zhCNLocale,
    ...elementZhCNLocale
  },
  [I18nLocaleCode.JP]: {
    ...jaLocale,
    ...elementJALocale
  },
  [I18nLocaleCode.MY]: {
    ...msMYLocale,
    ...elementEnLocale
  },
  [I18nLocaleCode.TH]: {
    ...thTHLocale,
    ...elementEnLocale
  }
}

const getBestLanguage = (languagesAvailable, defaultLanguage) => {
  const navigatorLanguage = store.getters.language || window.navigator.userLanguage || window.navigator.language
  if (typeof navigatorLanguage === 'undefined') {
    return defaultLanguage
  }
  for (let i = 0; i < languagesAvailable.length; i++) {
    const lang = languagesAvailable[i]
    if (lang === navigatorLanguage || lang.toLowerCase() === navigatorLanguage) {
      return lang
    }
  }
  for (let i = 0; i < languagesAvailable.length; i++) {
    const lang = languagesAvailable[i]
    if (lang.split('-')[0] === navigatorLanguage || navigatorLanguage.split('-')[0] === lang) {
      return lang
    }
  }
  return defaultLanguage
}

const setDefLanguage = (lang) => {
  store.dispatch('setLanguage', lang)
  return lang
}

const i18n = new VueI18n({
  locale: setDefLanguage(getBestLanguage(languagesAvailable, defaultLanguage)),
  fallbackLocale: defaultLanguage,
  messages
})

export default i18n
